function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: props.fill,
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(180)",
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M12.94,22H11.05a1.68,1.68,0,0,1-1.68-1.68V19.23a.34.34,0,0,0-.22-.29.38.38,0,0,0-.41,0l-.74.8a1.67,1.67,0,0,1-2.37,0L4.26,18.4a1.66,1.66,0,0,1-.5-1.19A1.72,1.72,0,0,1,4.26,16L5,15.26a.34.34,0,0,0,0-.37c-.06-.15-.16-.26-.3-.26H3.68A1.69,1.69,0,0,1,2,12.94V11.05A1.68,1.68,0,0,1,3.68,9.37H4.77a.34.34,0,0,0,.29-.22.38.38,0,0,0,0-.41L4.26,8a1.67,1.67,0,0,1,0-2.37L5.6,4.26a1.65,1.65,0,0,1,1.18-.5A1.72,1.72,0,0,1,8,4.26L8.74,5a.34.34,0,0,0,.37,0c.15-.06.26-.16.26-.3V3.68A1.69,1.69,0,0,1,11.06,2H13a1.68,1.68,0,0,1,1.68,1.68V4.77a.34.34,0,0,0,.22.29.38.38,0,0,0,.41,0l.69-.8a1.67,1.67,0,0,1,2.37,0L19.74,5.6a1.67,1.67,0,0,1,.5,1.19A1.63,1.63,0,0,1,19.74,8L19,8.74a.34.34,0,0,0,0,.37c.06.15.16.26.3.26h1.09A1.69,1.69,0,0,1,22,11.06V13a1.68,1.68,0,0,1-1.68,1.68H19.23a.413.413,0,0,0-.29.59l.77.77a1.67,1.67,0,0,1,0,2.37L18.4,19.74a1.65,1.65,0,0,1-1.18.5,1.72,1.72,0,0,1-1.19-.5L15.26,19a.34.34,0,0,0-.37,0c-.15.06-.26.16-.26.3v1.09A1.69,1.69,0,0,1,12.94,22Zm-1.57-2h1.26v-.77a2.33,2.33,0,0,1,1.46-2.14,2.36,2.36,0,0,1,2.59.47l.54.54.88-.88-.54-.55a2.366,2.366,0,0,1,1.66-4.01H20V11.37h-.77a2.33,2.33,0,0,1-2.14-1.46,2.36,2.36,0,0,1,.47-2.59l.54-.54-.88-.88-.55.54a2.39,2.39,0,0,1-4-1.67V4h-1.3v.77A2.33,2.33,0,0,1,9.91,6.91a2.36,2.36,0,0,1-2.59-.47L6.78,5.9l-.88.88.54.55a2.39,2.39,0,0,1-1.67,4H4v1.26h.77a2.33,2.33,0,0,1,2.14,1.46,2.36,2.36,0,0,1-.47,2.59l-.54.54.88.88.55-.54a2.39,2.39,0,0,1,4,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Zm0-5A1.5,1.5,0,1,0,13.5,12,1.5,1.5,0,0,0,12,10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.81e6441d2f7b0ebed47f8bbb4dabed4c.svg";
export { ForwardRef as ReactComponent };